import PropTypes from 'prop-types';

export const ShareableListCardPropTypes = {
  list: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    itemCount: PropTypes.number,
    listAccessType: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string
    }))
  }),
  numberOfThumbnails: PropTypes.number,
  disableSharedIcon: PropTypes.bool,
  sharedIconSize: PropTypes.oneOf(['small', 'medium', 'large'])
};

export const ShareableListCardDefaultProps = {
  list: null,
  numberOfThumbnails: 2,
  disableSharedIcon: false,
  sharedIconSize: 'small'
};

// Extract common list item properties for reuse
export const listItemPropTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  itemCount: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string
  })),
  numberOfThumbnails: PropTypes.number.isRequired
};

// Specific prop types for ListImages component
export const listImagesPropTypes = {
  itemCount: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string
  })),
  numberOfThumbnails: PropTypes.number.isRequired
};

// Specific prop types for ListHeader component
export const listHeaderPropTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  itemCount: PropTypes.number.isRequired
};
